export class EmailDesignController {

    constructor($log, UserSessionService, $analytics) {
        'ngInject';

        this.$log = $log;
        this.userSessionService = UserSessionService;
        this.$analytics = $analytics;

        this.$analytics.pageTrack('/email-design');
        this.$analytics.eventTrack('open', {  category: 'Email design' });

    }

    submit() {

        let data = _.pick(this.formData, ['name', 'email_address']);

        this.loading = true;

        this.userSessionService.emailDesign(data).then((response) => {
            this.loading = false;
            this.success = true;

            this.$analytics.pageTrack('/email-design/complete');
            this.$analytics.eventTrack('submit', {  category: 'Email design' });
            this.$log.debug('success', response);
        }).catch((response) => {
            this.loading = false;
            this.errors = response.data;
            this.$analytics.eventTrack('invalid', {category: 'Email design'});
            this.$log.debug('failed', response);
        });

    }

}



// WEBPACK FOOTER //
// ./src/js/components/email-design/email-design.controller.js